import { esusApi } from "@/services/api";
import { DentalAttendance } from "@/@types/esus/DentalAttendance";

export type DetailedCitizenAttendancesIndicatorB1Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenAttendancesIndicatorB1 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	dentalAttendances?: DentalAttendance[];
}

export async function getDetailedCitizenAttendancesIndicatorB1({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenAttendancesIndicatorB1Params) {
	const response = await esusApi.get<DetailedCitizenAttendancesIndicatorB1>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b1/detailed-citizen-attendances`,
		params
	);
	return response.data ?? new DetailedCitizenAttendancesIndicatorB1();
}
